import { Text } from "@src/components/Text";
import { StyleSheet } from "react-native-unistyles";
import { track } from "@visioni/a3s-analytics";
import { ContactUsClicked } from "@src/features/auth/analytics";

const CONTACT_URL = "https://www.visioni.com.au/contact";

export function ContactUsButton() {
  return (
    <a
      href={CONTACT_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", cursor: "pointer" }}
      onClick={() => track(ContactUsClicked)}
    >
      <Text textStyle="sm/regular" textAlign="center" style={styles.secondaryText}>
        Contact Us
      </Text>
    </a>
  );
}

const styles = StyleSheet.create((theme) => ({
  secondaryText: {
    color: theme.colors.interactive.controls.secondary_foreground,
  },
}));
